import React, { useState, useEffect } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const NAV_LINKS = [{
  label: 'El Problema',
  href: '#lead'
}, {
  label: 'Por qué funciona',
  href: '#mechanism'
}, {
  label: 'Qué incluye',
  href: '#includes'
}, {
  label: 'Historia',
  href: '#story'
}, {
  label: 'Para quién',
  href: '#for-whom'
}, {
  label: 'Inversión',
  href: '#investment'
}, {
  label: 'Preguntas',
  href: '#faq'
}];
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const closeMenu = () => setIsMobileMenuOpen(false);
  return <header className={`fixed top-0 left-0 right-0 z-40 transition-colors duration-300 ${isScrolled ? 'bg-charcoal/95 backdrop-blur-md py-4 shadow-lg border-b border-charcoal-light' : 'bg-transparent py-6'}`} data-id="element-129" data-mp="3fcrrnowfksql">
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between gap-6" data-id="element-130" data-mp="2mmon8k4ier54">
        <a href="#hero" className="text-2xl font-heading font-bold tracking-[0.2em] text-offwhite hover:text-sand transition-colors shrink-0" data-id="element-131" data-mp="2mohw862lhnga">
          ELEV<span className="text-sand" data-id="element-132" data-mp="3fass53f9b06r">ATE</span>
        </a>

        {/* Desktop Nav */}
        <nav className="hidden lg:flex items-center gap-7" data-id="element-133" data-mp="3adk9z2u3yw5i">
          {NAV_LINKS.map(link => <a key={link.href} href={link.href} className="text-xs font-medium text-offwhite-dim hover:text-sand transition-colors uppercase tracking-wider whitespace-nowrap" data-id="element-134" data-mp="35k7wnouvqbs2">
              {link.label}
            </a>)}
          <a href="https://wa.link/we351n" target="_blank" rel="noopener noreferrer" className="px-5 py-2.5 bg-sand/10 text-sand border border-sand/30 hover:bg-sand hover:text-charcoal-dark transition-colors duration-300 rounded-sm font-heading text-xs font-bold uppercase tracking-wider whitespace-nowrap" data-id="element-135" data-mp="3ta2aa8n0w4dd">
            Agendar llamada
          </a>
        </nav>

        {/* Mobile Menu Toggle */}
        <button className="lg:hidden text-offwhite hover:text-sand transition-colors" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-expanded={isMobileMenuOpen} aria-label="Abrir menú" data-id="element-136" data-mp="18n3dqk9mf0hu">
          {isMobileMenuOpen ? <XIcon className="w-7 h-7" data-id="element-137" data-mp="yr08h5jh2lqo" /> : <MenuIcon className="w-7 h-7" data-id="element-138" data-mp="13p1t3uwjqt49" />}
        </button>
      </div>

      {/* Mobile Accordion Menu */}
      <AnimatePresence data-id="element-139" data-mp="2t3gdk30j7tty">
        {isMobileMenuOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="lg:hidden overflow-hidden bg-charcoal-dark border-b border-charcoal-light" data-id="element-140" data-mp="2y2jizokfc22g">
            <nav className="flex flex-col px-6 py-4" data-id="element-141" data-mp="w5sm28bij6id">
              {NAV_LINKS.map(link => <a key={link.href} href={link.href} onClick={closeMenu} className="text-base font-medium text-offwhite-dim hover:text-sand transition-colors uppercase tracking-wider py-3 border-b border-charcoal-light/50" data-id="element-142" data-mp="rcgaayrxmu71">
                  {link.label}
                </a>)}
              <a href="https://wa.link/we351n" target="_blank" rel="noopener noreferrer" onClick={closeMenu} className="mt-5 text-center px-5 py-3.5 bg-sand text-charcoal-dark font-heading font-bold uppercase tracking-wider rounded-sm text-sm" data-id="element-143" data-mp="1a5k3yk55h71n">
                Agendar llamada gratuita
              </a>
            </nav>
          </motion.div>}
      </AnimatePresence>
    </header>;
}